export enum LSKeysEnum {
  USER = 'user',
  ANONYMOUS = 'anonymous',
  IS_CONFIRM_COOKIE = 'isConfirmCookie',
  COUPONS_SYNC_QUEUE = 'COUPONS_SYNC_QUEUE',
}
